import { createContext, useContext } from "react";

// env
const {
  REACT_APP_PRECONFIG_DATASTORE_LAMBDA_ARN,
} = process.env;

const ConfigContext = createContext();

export const useConfigContext = () => {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error("useConfigContext must be used within a ConfigContext");
  }
  return context;
}

// values
const listOfSupportedCountries = [
  {id:"malaysia", name:"Malaysia", avatar:"https://www.worldometers.info//img/flags/small/tn_my-flag.gif", country_code:"MY", currency:"MYR", aws_region:"ap-southeast-1"}
];

export const ConfigProvider = (props) => {

  // input
  const { children } = props;

  return (
    <ConfigContext.Provider 
      value={{
        list_of_supported_countries: listOfSupportedCountries,
        default: {
          country_id: 'malaysia',
          country_name: 'Malaysia',
          currency: 'MYR',
          country_code: 'MY'
        }
      }}
    >
      {children}
    </ConfigContext.Provider>
  )
}